import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import FundsPortfolioView from "@/features/K1Dashboard/views/FundsPortfolioView";

export default function K1FundsPortfolio() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portfolio");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <FundsPortfolioView />
      </main>
    </K1DashboardProvider>
  );
}
